import type { Order } from 'domain-model/types/oms';
import { SOCKET } from './action-type';
import type { Action } from '../types';

export const ACTION_TYPES = {
  RESET_PLACED_ORDERS: 'RESET_PLACED_ORDERS',
};

export interface CheckoutState {
  placedOrders: Order[];
}

const initialState = (): CheckoutState => ({
  placedOrders: [],
});

// my linter complains that default is not last, can't be arsed
// eslint-disable-next-line default-param-last
const checkoutReducer = (state = initialState(), action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.RESET_PLACED_ORDERS: {
      return {
        ...state,
        placedOrders: [],
      };
    }
    case SOCKET('ORDER_PLACED'): {
      const { fullEntity } = payload;
      return {
        ...state,
        placedOrders: [...state.placedOrders, fullEntity],
      };
    }
    default:
      return state;
  }
};

export default checkoutReducer;
